import React, { useState, useEffect } from 'react';
import '../../styles/components/UsersList.scss';
import { Box, Typography, Button, Modal, TextField, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Switch } from '@mui/material';

const roles = [
  { value: 'admin', label: 'Administrador' },
  { value: 'viewer', label: 'Lector' },
];

function UserModal({ openModal, selectedUser, handleCloseModal, handleSaveUser }) {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);

  const [emailError, setEmailError] = useState(false);

  const [isEmailValid, setIsEmailValid] = useState(false);

  useEffect(() => {
    if (selectedUser?.email) {
      setEmail(selectedUser.email);
      setRole(selectedUser.role.toLowerCase());
      setIsActive(!!selectedUser.is_active);
      setIsNewUser(false);
      setIsEmailValid(true)
    } else {
      setEmail("");
      setRole("");
      setIsActive(false);
      setIsNewUser(true);
      setIsEmailValid(false)
    }
  }, [selectedUser]);

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    setIsEmailValid(validateEmail(value));
  };

  const handleEmailBlur = () => {
    setEmailError(!isEmailValid || !email);
  };

  const handleRoleChange = (event) => setRole(event.target.value);
  const handleActiveChange = (event) => setIsActive(event.target.checked);

  const onSave = () => {
    if (validateFields()) {
      const userData = { email, role, is_active: isActive };
      handleSaveUser(userData, isNewUser);
    }
  };

  const validateFields = () => {
    setEmailError(!isEmailValid || !email);
    return isEmailValid && email && role;
  };

  const handleLocalCloseModal = () => {
    setEmailError(false);
    handleCloseModal();
  };

  return (
    <Modal open={openModal} onClose={handleLocalCloseModal} data-testid="user-modal">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 800,
          maxHeight: '80vh',
          overflowY: 'auto',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          {isNewUser ? "Crear Usuario" : "Editar Usuario"}
        </Typography>
        <TextField
          fullWidth
          label="Email"
          variant="outlined"
          margin="normal"
          value={email}
          onChange={handleEmailChange}
          onBlur={handleEmailBlur}
          disabled={!isNewUser}
          error={emailError}
          helperText={emailError ? "Por favor ingresa un email válido" : ""}
        />
        <FormControl fullWidth margin="normal">
          <InputLabel id="role-select-label">Rol</InputLabel>
          <Select
            labelId="role-select-label"
            value={role}
            onChange={handleRoleChange}
            label="Rol"
          >
            {Array.isArray(roles) && roles.map((role) => (
              <MenuItem key={role.value} value={role.value}>
                {role.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControlLabel
          style={{ width: "100%" }}
          control={<Switch checked={isActive} onChange={handleActiveChange} />}
          label="Usuario activo"
        />
        <Button
          variant="contained"
          onClick={onSave}
          sx={{ mt: 2, mr: 2 }}
          disabled={!isEmailValid || !email || !role}
        >
          Guardar Cambios
        </Button>
        <Button variant="outlined" onClick={handleLocalCloseModal} sx={{ mt: 2 }}>
          Cancelar
        </Button>
      </Box>
    </Modal>
  );
}

export default UserModal;
